import React, { useEffect, useState } from "react";
import { Container, Table, Button ,FormGroup,Label,Input} from "reactstrap";
import {
  GetUserList,
  EnableUser,
  BlockUser,
  UnblockUser,
  DisableUser,
} from "services/api/user";
import SignupModel from "../../../components/Modal";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { toastNotification } from "components/Toast";
import { DepartmentList } from "services/api/department";
import { ProfileList } from "services/api/profile";
import EditForm from "./EditForm";

function UserTable() {
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [searchUser, setSearchUser] = useState("");
  const [filters, setFilters] = useState({
  department: "",
  profile: "",
  status: ""
});
const [departments,setDepartment] =  useState("");
const [roles,setRoles] = useState("")

  const [userListData, setUserListData] = useState();
  const [show, setShow] = useState(false);
  const [editShow,seteditShow] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(false);
  // const [skipNo, setSkipNo] = useState(0)

  // pagination
  const [count, setCount] = useState(5);
  const [pageNumber, setPageNumber] = useState(1);

  const location = useLocation();
  const [section, setSection] = useState(location.pathname.split("/")[1]);


  useEffect(() => {
  async function fetchData() {
    console.log(filters)
    const res = await GetUserList(count, pageNumber, searchUser,filters);
    console.log(res)
    setUserListData(res?.data?.data);

    let response = await DepartmentList();
    setDepartment(response?.data?.data)

    let resp = await ProfileList();
    setRoles(resp?.data?.data)
  }
  fetchData();
}, [refresh, count, pageNumber, searchUser]);

const handleSearch = () => {
  setPageNumber(1);
  setRefresh(!refresh);
};


const handleEditUser = (user) => {
  setSelectedUser(user)
  seteditShow(true)
}
  const handleAddUser = () => {
    setShow(true);
  };
  const handleEnableUser = async (id) => {
    let res = await EnableUser(id)
    toastNotification("success", res?.data?.message)
    setRefresh(!refresh);
  };
  const handleDisableUser = async (id) => {
    let res = await DisableUser(id);
    toastNotification("error", res?.data?.message)
    setRefresh(!refresh);
  };
  const handleBlockUser = async (id) => {
    let res = await BlockUser(id);
    setRefresh(!refresh);
  };
  const handleUnblockUser = async (id) => {
    let res = await UnblockUser(id);
    setRefresh(!refresh);
  };
  const hanldeIncrement = async (el, i) => {
    setPageNumber(pageNumber + 1);
    setRefresh(!refresh);
  };
  const handleDecrement = async (el, i) => {
    setPageNumber(pageNumber - 1);
    setRefresh(!refresh);
  };

  const rowStyles = {
    padding: "20px 0",
  };

  return (
    <>
      {show ? (
        <SignupModel
          section={section}
          refresh={refresh}
          setRefresh={setRefresh}
          userListData={userListData}
          setUserListData={setUserListData}
          setShow={setShow}
          show={show}
        />
      ) : null}
      {editShow ? (
        <EditForm
          refresh={refresh}
          setRefresh={setRefresh}
          seteditShow={seteditShow}
          editShow={editShow}
          selectedUser={selectedUser}
        />
      ) : null}
      <div className="mt-5 mt-md-0" style={{ backgroundColor: "white" }}>
        <Container className="mb-5">
          <h4>User Section</h4>
        </Container>
        <Container className="mb-3 sideByside">
          <select
            value={count}
            onChange={(e) => {
              setCount(e.target.value);
              setPageNumber(1);
              setRefresh(!refresh);
            }}
            style={{ width: "100px" }}
          >
            {/* <option hidden selected>Select page no.</option> */}
            <option value="5" selected>
              5
            </option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
          </select>

      
    <FormGroup>
      <Label for="searchUser">Search by Name</Label>
      <Input
        id="searchUser"
        type="text"
        placeholder="Enter user name"
        value={searchUser}
        onChange={(e) => setSearchUser(e.target.value)}
      />
    </FormGroup>
 
<Button
  color="info"
  onClick={() => setShowFilterMenu(!showFilterMenu)}
  className="mb-3"
>
  {showFilterMenu ? "Hide Filters" : "Show Filters"}
</Button>

{showFilterMenu && (
  <FormGroup className="p-3 border rounded" style={{ maxWidth: "400px" }}>
    <Label for="departmentFilter">Department</Label>
    <Input
      type="select"
      id="departmentFilter"
      value={filters.department}
      onChange={(e) =>
        setFilters({ ...filters, department: e.target.value })
      }
      className="mb-2"
    >
      <option value="">All</option>
      {departments.map((value, idx) => (
        <option key={idx} value={value?._id}>
           {value.name}
        </option>
      ))}
    </Input>

    <Label for="roleFilter">Profile</Label>
    <Input
      type="select"
      id="roleFilter"
      value={filters.profile}
      onChange={(e) =>
        setFilters({ ...filters, profile: e.target.value })
      }
      className="mb-2"
    >
      <option value="">All</option>
      {roles.map((value, idx) => (
        <option key={idx} value={value?._id}>
          {value.name}
        </option>
      ))}
    </Input>

    <Label for="statusFilter">Status</Label>
    <Input
      type="select"
      id="statusFilter"
      value={filters.status}
      onChange={(e) => setFilters({ ...filters, status: e.target.value })}
      className="mb-3"
    >
      <option value="">All</option>
      <option value="0">Inactive</option>
      <option value="1">Active</option>
      <option value="2">Blocked</option>
    </Input>

    <Button color="primary" block onClick={handleSearch}>
      Apply Filters
    </Button>
  </FormGroup>
)}
          <Button color="primary" onClick={handleAddUser}>
            Add User
          </Button>
        </Container>
        <Container className="shape-container d-flex align-items-center  ">
          {userListData?.length ? (
            <Table bordered size="sm" className="user-table ">
              <thead>
                <tr className="user-table">
                  <th>S.no</th>
                  <th>Name</th>
                  <th>Username</th>
                  <th>Department</th>
                  <th>Profile</th>
                  <th>Status</th>
                  <th className="text-center">Actions </th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
                {userListData?.map((val, i) => {
                  return (
                    <>
                      <tr key={i} className="user-table-col">
                        <td style={rowStyles}>{i + 1}</td>
                        <td style={rowStyles}>{val.name}</td>
                        <td style={rowStyles}>{val.username}</td>
                        <td style={rowStyles}>{val.department.name}</td>
                        <td style={rowStyles}>{val.profile.name}</td>
                        <td style={rowStyles}>{val.status}</td>
                        <td style={rowStyles}>
                          <div>
                          
                            {val.status == 0 ? (
                              <div>
                               <Button
                                  color="success"
                                  onClick={() => handleEditUser(val)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  color="success"
                                  onClick={() => handleEnableUser(val._id)}
                                >
                                  Enable
                                </Button>
                                <Button
                                  color="dark"
                                  onClick={() => handleBlockUser(val._id)}
                                >
                                  Block
                                </Button>
                              </div>
                            ) : val.status == 1 ? (
                              <div>
                               <Button
                                  color="success"
                                  onClick={() => handleEditUser(val)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  color="danger"
                                  onClick={() => handleDisableUser(val._id)}
                                >
                                  Disable
                                </Button>
                                <Button
                                  color="dark"
                                  onClick={() => handleBlockUser(val._id)}
                                >
                                  Block
                                </Button>
                              </div>
                            ) : (
                              <div>
                               <Button
                                  color="success"
                                  onClick={() => handleEditUser(val)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  disabled
                                  color="danger"
                                  onClick={() => handleDisableUser(val._id)}
                                >
                                  Disable
                                </Button>
                                <Button
                                  color="success"
                                  onClick={() => handleUnblockUser(val._id)}
                                >
                                  UnBlock
                                </Button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <div className="text-center w-100">
              <p>No Results Found</p>
            </div>
          )}
        </Container>
        <div className="mt-3">
          <Container>
            <Button
              color="primary"
              disabled={pageNumber == 1 ? true : false}
              onClick={() => handleDecrement()}
            >
              <FaChevronLeft />
            </Button>
            <span className="whiteBold mr-2">{pageNumber}</span>
            <Button
              color="primary"
              disabled={userListData?.length < count ? true : false}
              onClick={() => hanldeIncrement()}
            >
              <FaChevronRight />
            </Button>
          </Container>
        </div>
      </div>
    </>
  );
}

export default UserTable;
